import {
    setUserSportAction,
    setSportRelationshipAction,
    setOnBoardingPlaceAction,
    setOnBoardingBirthdayAction,
    setAchievementTextAction,
    setAchievementSportAction,
    setOnBoardingStepAction,
} from '../../admin/actions/on-boarding'
import {
    ON_BOARDING_STEP_ACHIEVEMENT,
    ON_BOARDING_STEP_BIRTHDAY,
    ON_BOARDING_STEP_CITY,
    ON_BOARDING_STEP_RELATIONSHIP,
    ON_BOARDING_STEP_WELCOME,
} from './hoc'

/**
 * Parse user on-boarding into store and set a current step
 * @param {Object} user
 * @param {Array} sports
 */
export const setUserOnBoardingToStore = (user, sports) => {
    const userOnBoardingSport = user?.sports?.data?.[0]
    const userOnBoardingAchievement = user?.achievements?.data?.[0]

    const userSport = sports?.find?.(_sport => _sport?.id === userOnBoardingSport?.sport_id)
    const userSportRelations = userOnBoardingSport?.relationships?.data?.map?.(_relationship => _relationship?.relationship_id)
    const userSportLocation = userOnBoardingSport?.locations?.data?.[0]
    const userBirthday = user?.birthday
    const userAchievementSport = sports?.find?.(_sport => _sport?.id === userOnBoardingAchievement?.sport_id)
    const userAchievementDescription = userOnBoardingAchievement?.description

    let currentStep = ON_BOARDING_STEP_WELCOME

    if (userSport) {
        const convertedSport = [createSportObject(userSport)]
        currentStep = ON_BOARDING_STEP_RELATIONSHIP
        setUserSportAction(convertedSport)
    }
    if (userSportRelations) {
        setSportRelationshipAction(userSportRelations)

        if (userSport) {
            currentStep = ON_BOARDING_STEP_CITY
        }
    }
    if (userSportLocation) {
        setOnBoardingPlaceAction(userSportLocation)

        if (userSport && userSportRelations) {
            currentStep = ON_BOARDING_STEP_BIRTHDAY
        }
    }
    if (userBirthday) {
        setOnBoardingBirthdayAction(userBirthday)

        // If users has filled birthday from past and has not filled first steps from OnBoarding, can NOT go to achievement step
        if (userSport && userSportRelations && userSportLocation) {
            currentStep = ON_BOARDING_STEP_ACHIEVEMENT
        }
    }
    if (userAchievementSport) {
        const convertedSport = createSportObject(userAchievementSport)
        setAchievementSportAction(convertedSport)
    }
    if (userAchievementDescription) {
        setAchievementTextAction(userAchievementDescription)
    }

    setOnBoardingStepAction(currentStep)
}

/**
 * Create sport object for on-boarding
 * @param {Object} sport
 * @return {null|{label: *, value: *}}
 */
const createSportObject = sport => {
    if (!sport) {
        return null
    }

    return {
        value: sport.id,
        label: sport.name,
    }
}
